import storeModule from './store-module'
import { defineStore } from 'pinia'

export default defineStore('signatory-types', storeModule.createStoreModule('signatory-types'))
